"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TokenUserMetadataView = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_intl_1 = require("react-intl");
const mui_scanner_1 = require("@dzambalaorg/mui-scanner");
const ui_kit_1 = require("@dzambalaorg/ui-kit");
const constants_1 = require("@framework/constants");
const TokenUserMetadataView = props => {
    const { metadata } = props;
    if (!metadata?.USER || metadata.USER === constants_1.ZeroAddress) {
        return null;
    }
    return ((0, jsx_runtime_1.jsxs)(ui_kit_1.Table.Row, { children: [(0, jsx_runtime_1.jsx)(ui_kit_1.Table.Cell, { component: "th", scope: "row", children: (0, jsx_runtime_1.jsx)(react_intl_1.FormattedMessage, { id: "form.labels.user" }) }), (0, jsx_runtime_1.jsx)(ui_kit_1.Table.Cell, { align: "right", children: (0, jsx_runtime_1.jsx)(mui_scanner_1.AddressLink, { address: metadata.USER, length: 42 }) })] }));
};
exports.TokenUserMetadataView = TokenUserMetadataView;
//# sourceMappingURL=user-metadata.js.map